"use client";

import { GitHubCalendar } from "react-github-calendar";
import { useTheme } from "next-themes";
import { useMediaQuery, BREAKPOINTS } from "@/hooks/use-media-query";
import { BlurReveal } from "@/components/blur-reveal";

export default function GithubGraph() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme !== "light";
  const isMobile = !useMediaQuery(BREAKPOINTS.md);
  const isLargeDesktop = useMediaQuery(BREAKPOINTS.lg);

  const blockSize = isMobile ? 5 : isLargeDesktop ? 13 : 9;
  const blockMargin = isMobile ? 1 : isLargeDesktop ? 3 : 2;
  const fontSize = isMobile ? 9 : isLargeDesktop ? 12 : 10;

  return (
    <BlurReveal>
      <div className="mx-auto mt-10 w-full max-w-3xl border-t border-border/50 pt-10 lg:max-w-5xl">
        <div className="mb-6 flex items-center justify-center gap-3">
          <span className="font-mono text-[10px] tracking-widest text-muted-foreground/40">05</span>
          <h3 className="text-xs font-bold tracking-[0.2em] text-muted-foreground uppercase">
            GitHub Activity
          </h3>
        </div>
        <div className="rounded-2xl border border-border/50 bg-secondary/5 p-5 md:p-6 lg:p-8">
          <div className="flex min-h-[120px] justify-center overflow-x-auto lg:min-h-[160px]">
            <GitHubCalendar
              username="MikkelScheike"
              colorScheme={isDark ? "dark" : "light"}
              style={{
                fontFamily: "var(--font-inter), monospace",
              }}
              blockSize={blockSize}
              blockMargin={blockMargin}
              fontSize={fontSize}
            />
          </div>
          <p className="mt-4 text-center font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
            Contributions over the last year
          </p>
        </div>
      </div>
    </BlurReveal>
  );
}
